import {useNavigate, useLocation} from 'react-router-dom';
import {useCallback, useEffect, useRef} from 'react';

export type InterceptedLocation = ReturnType<typeof useLocation> | 'BACK';
export type Listener = () => void;

export const useNavigationInterceptor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);
  const isEnabledRef = useRef(false);
  const listenerRef = useRef<Listener>();
  const interceptedLocationRef = useRef<InterceptedLocation>();

  const setEnabled = useCallback((isEnabled: boolean) => {
    isEnabledRef.current = isEnabled;
    // No history.block in React Router v6, so this logic should be replaced with custom navigation handling if needed
  }, []);

  const getEnabled = useCallback(() => {
    return isEnabledRef.current;
  }, []);

  const goInterceptedLocation = useCallback(() => {
    if (interceptedLocationRef.current === 'BACK') {
      isEnabledRef.current = false;
      navigate(-1);
    } else if (interceptedLocationRef.current) {
      navigate(interceptedLocationRef.current as any);
    }
  }, [navigate]);

  // Listen for location changes if needed
  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  return {
    onNavigationIntercepted: (listener: Listener) => {
      listenerRef.current = listener;
    },
    goInterceptedLocation,
    setEnabled,
    getEnabled,
  };
};
